/**
 * Created by olga on 17.03.2026
 */

const Merge2UnitShopControlButton = {
    name: "Merge2UnitShopControlButton",
    buttonType: "control_button",
    icon: bundles.controlbuttons.frames.shopping_cart_icon_png,

    onClicked: function () {
        const shops = cleverapps.unitsShop.getAvailableShops();
        const shop = shops.find((shop) => ShopProductSource.hasAttention(shop.tab)) || shops[0];
        const targetTab = shop.tab;

        cleverapps.focusManager.display({
            stack: true,
            focus: `displayUnitsShop${targetTab}`,
            control: ["MenuBarGoldItem"],
            actions: [
                function (f) {
                    if (Merge2.current.mode === Merge2.MODE_META) {
                        Merge2.current.changeMode(Merge2.MODE_GAME, f);
                    } else {
                        f();
                    }
                },
                (f) => {
                    new Merge2UnitsShopWindow({ tab: targetTab });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                },
                (f) => {
                    const cart = cleverapps.persist.acceptNode("UnitsShopCart");
                    if (cart) {
                        cart.processItems(f);
                    } else {
                        f();
                    }
                }
            ]
        });
    },

    isAvailableOnScene: function () {
        return cleverapps.environment.isMainScene();
    },

    isAvailable: function () {
        return Merge2.current && Merge2.current.mode === Merge2.MODE_GAME && cleverapps.unitsShop.isAvailable();
    },

    onUpdateAttention: function () {},

    updateAttention: function () {
        if (!this.isAvailable()) {
            return false;
        }

        const hasAttention = !!Object.values(cleverapps.unitsShop.tabs).find((tab) => tab.needsAttention());

        this.onUpdateAttention(hasAttention);
    }
};
